var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import { getGeometryStyle } from '../../helpers/styles';
var StyledProgressBar = styled.progress.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var geometry = _a.geometry;
    return getGeometryStyle(geometry);
});
var ProgressBar = function (props) {
    var identifier = props.identifier, attributes = props.attributes, children = props.children, windowId = props.windowId, restProps = __rest(props, ["identifier", "attributes", "children", "windowId"]);
    var enabled = attributes.enabled, maximum = attributes.maximum, geometry = attributes.geometry, value = attributes.value;
    var disabled = enabled === 'false';
    return (React.createElement(StyledProgressBar, __assign({ geometry: geometry, value: value || 0, max: maximum || 100, disabled: disabled }, restProps)));
};
export default ProgressBar;
var templateObject_1;
//# sourceMappingURL=index.js.map